import { Injectable } from '@angular/core';
import { HttpFunctionsService } from '../http-services/http-functions.service';
import { catchError, map } from 'rxjs/operators';
import { throwError } from 'rxjs'
import { UserDetails } from 'src/app/models/user-details.model';
@Injectable({
  providedIn: 'root'
})
export class UserService {
  userUrl: string = 'user/';
  beatUrl: string = 'beat/';
  aadharUrl: string = 'idvalidation/aadhaar';
  aadharGUrl: string = 'idvalidation/guardian';
  passportUrl: string = 'idvalidation/passport';
  mobileUrl: string = 'idvalidation/mobile/';
  constructor( private commonMethods: HttpFunctionsService) { }

  /**
   * Get User List
   * @returns 
   */
    getUserList() {
      return this.commonMethods.postMethod(this.userUrl+'list',{});
    }
  /**
   * Get User List
   * @returns 
   */
    getCurrentUserDetails() {
      return this.commonMethods.getMethod(this.userUrl);
    }

    updatePhoneNumber(sendData: any) {
      return this.commonMethods.putMethod(this.userUrl+"updateMobileNumber",sendData);
    }

    /**
     * Generate Mobile Number OTP 
     * @param mobNumber 
     * @returns 
     */
    generateMobileNumberOtp(mobNumber: any) {
      let dataSend = {
        mobileNumber: mobNumber
      }
      return this.commonMethods.postMethod(this.mobileUrl+"generate-otp", dataSend);
    }

    verifyMobileOTP(clientId: any, otp: any) {
      let dataSend = {
        clientId: clientId,
        otp: otp
      }
      return this.commonMethods.postMethod(this.mobileUrl+"verify-otp",dataSend);
    }

    checkStatusMobileNumber() {
      return this.commonMethods.getMethodWithParams
    }

    verifyOtp(sendData: any) {
      return this.commonMethods.putMethod(this.userUrl+"verifyMobileOtp",sendData);
    }

    /**
     * Update Profile Data
     * @param sendData 
     * @returns 
     */
    updateParticularUserData(sendData:any, isShowLoader: boolean = true) {
      return this.commonMethods.putMethod(this.userUrl+'update',sendData, isShowLoader).pipe(map((res: UserDetails) => {
        return res
      }),catchError((error) => {
        return throwError(error);
      }))
    }

    /**
     * Bulk commercial data update
     * @param sendData 
     * @returns
     */
    bulkCommercialDataUpdate(sendData:any , isShowLoader: boolean = true) {
      return this.commonMethods.postMethod(this.beatUrl+'bulk-update-commercials',sendData, isShowLoader).pipe(map((res: any) => {
        return res
      }),catchError((error) => {
        return throwError(error);
      }));
    }

    /**
     * Update Profile Image
     * @param sendData 
     * @returns 
     */
    updateProfileImage(sendData:any) {
      return this.commonMethods.putMethod(this.userUrl+'pofile-picture/update',sendData,true);
    }

    /**
     * Delete user Profile
     * @returns 
     */
    deleteProfileImage() {
      return this.commonMethods.deleteMethod(this.userUrl+'pofile-picture/delete', null, true);
    }

    getProfileHandle() {
      return this.commonMethods.getMethod(this.userUrl + "profileHandle",true)
    }

    updateProfileHandle(newHandle: string) {
      return this.commonMethods.putMethod(this.userUrl + "profileHandle",{handle:newHandle}, true)
    }

    getMp3DownloadCount() {
      return this.commonMethods.getMethod(this.userUrl + "freeDownloadCount",true)
    }
  
  /**
   * Initialize Aadhaar validation
   * @returns 
   */
  aadhaarValidationIntilazation(calling: string) {
    let currentUrl = calling === "aadhar" ? this.aadharUrl :  this.aadharGUrl;
    return this.commonMethods.postMethod(currentUrl + '/init', {}, false);
  }

  /**
   * Get Aadhaar card status
   * @param digilockerId 
   * @returns 
   */
  aadharCardStatus(digilockerId: string, calling: string) {
    let data = {
      "client_id": digilockerId
    }
    let currentUrl = calling === "aadhar" ? this.aadharUrl :  this.aadharGUrl+"/verify";
    return this.commonMethods.postMethod(currentUrl,data, true);
  }

  /**
   * Get Aadhaar details
   * @returns 
   */
  getAadharDetails() {
    return this.commonMethods.getMethod(this.aadharUrl + '/details', true);
  }

  /**
   * Validate Passport
   * @param data 
   * @returns 
   */
  passportValidation(data: any) {
    return this.commonMethods.postMethod(this.passportUrl, data, true);
  }

  /**
   * Get Passport Details
   * @returns 
   */
  getPassportDetails() {
    return this.commonMethods.getMethod(this.passportUrl + '/details', true);
  }

    /**
     * Initiate email update flow
     * @param sendData {currentPassword, newEmail}
     */
    initiateEmailUpdate(sendData: any) {
      return this.commonMethods.postMethod(this.userUrl + "email/update/initiate", sendData);
    }

    /**
     * Verify email update OTP
     * @param sendData {otp}
     */
    verifyEmailUpdate(sendData: any) {
      return this.commonMethods.postMethod(this.userUrl + "email/update/verify", sendData);
    }

}
